import React, { useEffect, useState } from "react";
import Logger from "../../services/Logger";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// message could be pre-defined message like 'updated'
//         or error message that is not pre-defined.
// severity : 'error' | 'info' | 'success' | 'warning'
export default function CustomSnackbar({ open, setOpen, message, severity }) {
    const [definedMessage, setDefinedMessage] = useState();

    useEffect(() => {
        // Logger.log("useEffect..... CustomSnackbar");
        // Logger.log(message);

        if (message == "updated") {
            setDefinedMessage("Updated successfully");
        } else if (message == "added") {
            setDefinedMessage("Added successfully");
        } else if (message == "saved") {
            setDefinedMessage("Saved successfully");
        } else if (message == "deleted") {
            setDefinedMessage("Deleted successfully");
        } else {
            setDefinedMessage(message);
        }
    }, [message, severity, open]);

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setOpen(false);
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
        >
            <Alert onClose={handleClose} severity={severity ? severity : "success"} sx={{ mr: 2 }}>
                {definedMessage}
            </Alert>
        </Snackbar>
    );
}
